import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { retailerFundedMarketingWholesalerAccessControl } from '../access-control/retailerFundedMarketingWholesalerAccess.configuration'
import { lifecycleCrmAccessControl } from '../access-control/lifecycleCrmAccess.configuration'
import { sfpCampaignAndSegmentAccessControl } from '../access-control/sfpCampaignAndSegmentAccess.configuration'

const MarketplaceCampaignListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MarketplaceCampaignListPage" */
      '../pages/retailer-campaigns/list/MarketplaceCampaignListPage'
    )
)
const StorefrontProCampaignListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontProCampaignListPage" */
      '../pages/retailer-campaigns/list/StorefrontProCampaignListPage'
    )
)
const PartnerCampaignCreatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "PartnerCampaignCreatePage" */
      '../pages/retailer-campaigns/create/PartnerCampaignCreatePage'
    )
)
const PartnerCampaignViewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "PartnerCampaignCreatePage" */
      '../pages/retailer-campaigns/view/PartnerCampaignViewPage'
    )
)
const PartnerCampaignEditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "PartnerCampaignEditPage" */
      '../pages/retailer-campaigns/view/PartnerCampaignEditPage'
    )
)
const LifecycleCrmPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LifecycleCrmPage" */
      '../pages/lifecycle-crm/LifecycleCrmPage'
    )
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const retailerFundedMarketingPartnerScopedRouter = (
  <DomainRoute
    route="campaigns-partner-scoped"
    accessControl={retailerFundedMarketingWholesalerAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="partner-scoped-campaigns-lifecycle-crm"
        tool="whitelabel-lifecycle-crm-dashboard-tool"
        component={LifecycleCrmPage}
        accessControl={lifecycleCrmAccessControl}
      />
      <DomainRoute
        exact
        route="campaigns-marketplace-list"
        tool="marketplace-campaigns-dashboard-tool"
        // @ts-ignore TODO: Fix strict mode violations
        component={MarketplaceCampaignListPage}
      />
      <DomainRoute
        exact
        route="campaigns-storefront-pro-list"
        tool="storefront-pro-campaigns-dashboard-tool"
        accessControl={sfpCampaignAndSegmentAccessControl}
        // @ts-ignore TODO: Fix strict mode violations
        component={StorefrontProCampaignListPage}
      />
      <DomainRoute
        exact
        route="partner-campaigns-create-mp"
        tool="marketplace-campaigns-dashboard-tool"
        // @ts-ignore TODO: Fix strict mode violations
        component={PartnerCampaignCreatePage}
      />
      <DomainRoute
        exact
        route="partner-campaigns-create-sfx"
        tool="storefront-pro-campaigns-dashboard-tool"
        accessControl={sfpCampaignAndSegmentAccessControl}
        // @ts-ignore TODO: Fix strict mode violations
        component={PartnerCampaignCreatePage}
      />
      {/* @ts-ignore TODO: Fix strict mode violations */}
      <DomainRoute exact route="partner-campaigns-edit" component={PartnerCampaignEditPage} />
      {/* @ts-ignore TODO: Fix strict mode violations */}
      <DomainRoute exact route="partner-campaigns-view" component={PartnerCampaignViewPage} />
      {/* @hygen:inject router-route
            injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
